import { buildStandardReducer } from 'utils/reducer-utils';
import * as types from './action-types';

export default buildStandardReducer(types);



// WEBPACK FOOTER //
// ./app/routes/agreement/store/reducers.js